import { REDUX_ACTIONS, GAME_ID } from 'a/cityPlanner/data/constants';

const initState = {
  shallRunAnimation: false,
  isPositive: true,
  duration: 0,
};

const particlesReducer = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.INITIALIZE_ROUND:
      return {
        ...initState,
      };

    case REDUX_ACTIONS.SET_PARTICLE_ANIMATION:
      return {
        ...state,
        ...payload,
        shallRunAnimation: true,
      };

    case REDUX_ACTIONS.STOP_PARTICLE_ANIMATION:
      return {
        ...state,
        shallRunAnimation: false,
      };

    default:
      return state;
  }
};

export default particlesReducer;
